<template>
	<div :class="classes">
		<div class="member-assessment-row__member-image">
			<UserAvatar
				:user="assessment.member"
			/>
		</div>
		<div class="member-assessment-row__member-details">
			<div class="member-assessment-row__member-name">
				<div>
					{{ assessment.member.displayName }}
				</div>
				<div :class="chipClasses">
					{{ moniker }}
				</div>
			</div>
			<div class="member-assessment-row__member-attributes">
				<div
					v-for="quality in featuredQualities"
					:key="quality"
					class="member-assessment-row__user-trait"
				>
					<span>{{ quality }}&nbsp;</span>
				</div>
			</div>
		</div>
		<div class="member-assessment-row__actions">
			<TeamingButton
				v-if="showCTA"
				type="SECONDARY"
				size="TINY"
				@click="$emit( `takeWorkStyleAssessment` )"
			>
				{{ translate( "takeNowButton" ) }}
			</TeamingButton>
		</div>
	</div>
</template>

<script>
import {
	TranslateMixin,
	UserAvatar,
	TeamingButton
} from "@teaming/common-ui";

const NO_MONIKER = "??";
const NO_HIGH_TYPE = "X";

export default {
	name: "MemberAssessmentRow",
	teamingPackage: "common-team",
	mixins: [ TranslateMixin, ],
	emits: [ "takeWorkStyleAssessment", ],
	components: {
		UserAvatar,
		TeamingButton,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
		assessment: {
			type: Object,
			required: true,
		},
	},
	computed: {
		classes() {
			return `member-assessment-row ${ this.className }`.trim();
		},
		highType() {
			return this.assessment?.highType || NO_HIGH_TYPE;
		},
		moniker() {
			return this.assessment?.moniker || NO_MONIKER;
		},
		showCTA() {
			return this.assessment.forCurrentUser &&
				this.moniker === NO_MONIKER;
		},
		featuredQualities() {
			const { featuredQualities = [], } = this.assessment;
			if ( featuredQualities.length === 0 ) {
				return [ this.translate( "noAssessmentLabel" ), ];
			}
			return featuredQualities;
		},
		chipClasses() {
			const { highType, } = this;
			return {
				"text-ms-1": true,
				"discTextLabel__hightype-chip": true,
				"discTextLabel__D-hightype-chip": highType === "D",
				"discTextLabel__I-hightype-chip": highType === "I",
				"discTextLabel__S-hightype-chip": highType === "S",
				"discTextLabel__C-hightype-chip": highType === "C",
				"discTextLabel__X-hightype-chip": highType === "X",
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.member-assessment-row {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: 0.5rem;
}

.member-assessment-row__member-details {
	@include font-and-line-for(0);
}

.member-assessment-row__member-image {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.member-assessment-row__member-name,
.member-assessment-row__member-attributes {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 0.5rem;
}

.member-assessment-row__member-name {
	font-weight: 600;
}

.member-assessment-row__member-attributes {
	color: $member-assessment-row-attributes-color;
}

.member-assessment-row__user-trait {
	&:not(:last-of-type):after {
		content: "\0020\2022\0020";
	}
}

.member-assessment-row__actions {
	display: flex;
	flex-direction: row-reverse;
	flex: 1;
}
</style>
